export const SELECT_TYPE = "select";
export const NUMERIC_TYPE = "number";
export const TEXT_TYPE = "text";
export const IMAGE_TYPE = "image";
export const AUDIO_TYPE = "audio";
